import * as Comp from "../../../common/CommonComponents";
import * as common from "../../../common/common";
import http from "../../../common/http-common";

import { useState } from "react";
import { useCookies } from "react-cookie";
import { toast } from "react-toastify";

const RoleActivator = (props) => {
  const [cookies] = useCookies([]);
  const [userId] = useState(cookies.USER_ID);

  //#region Modal Show/Hide
  const hideModal = () => {
    props.onHide();
  };
  //#endregion

  //#region Confirm Update Status
  const confirmBtnOnClick = () => {
    UpdateRoleStatus(props.editData);
  };

  const UpdateRoleStatus = (_data) => {
    let functionName = "";

    try {
      functionName = props.page + UpdateRoleStatus.name;

      props.onLoading(
        true,
        (_data.STATUS === "Active" ? "Deactivating" : "Activating") +
          " role, please wait..."
      );
      props.onHide();
      const data = {
        ROLE_ID: _data.ROLE_ID,
        ROLE_NAME: _data.ROLE_NAME,
        ACTIVE_FLAG: _data.STATUS === "Active" ? "N" : "Y",
        UPDATE_ID: userId,
        FROM_SOURCE: { SOURCE: "WEB" /*MODULE_ID: props.module*/ },
      };
      const action = data.ACTIVE_FLAG === "Y" ? "activate" : "deactivate";

      http
        .put("api/roles/UpdateRoleStatus", data, { timeout: 5000 })
        .then((response) => {
          toast.success("Role is successfully " + action + "d.");
          props.onReload();
        })
        .catch((err) => {
          toast.error("Failed to " + action + " role. Please try again.");
          common.c_LogWebError(props.page, functionName, err);
        })
        .finally(() => {
          props.onLoading(false, "Loading...");
        });
    } catch (err) {
      props.onLoading(false, "Loading...");
      const action = _data.ACTIVE_FLAG === "Y" ? "deactivate" : "activate";
      toast.error("Failed to " + action + " role. Please try again.");
      common.c_LogWebError(props.page, functionName, err);
    }
  };
  //#endregion

  const message = (
    <>
      Confirm to{" "}
      {props.editData !== null && props.editData.STATUS === "Active"
        ? "deactivate"
        : "activate"}
      ? <br /> Role Name:{" "}
      {<b> {props.editData !== null && props.editData.ROLE_NAME}</b>}
    </>
  );

  return (
    <>
      <Comp.ConfirmModal
        show={props.showHide}
        confirm={true}
        onHide={hideModal}
        onConfirm={confirmBtnOnClick}
      >
        {message}
      </Comp.ConfirmModal>
    </>
  );
};

export default RoleActivator;
